/**
 * Inline spinner for "loading more rows" or "fetching first page".
 * For full-page skeletons use `<PageSkeleton>` from `feedback/`.
 *
 * @example
 * {loading ? <LoadingState /> : <List>...</List>}
 */
export function LoadingState({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3">
      <div className="w-6 h-6 border-2 border-gray-200 dark:border-white/[0.08] border-t-primary rounded-full animate-spin" />
      {label && <p className="text-xs text-gray-400 dark:text-gray-500">{label}</p>}
    </div>
  );
}
